export default __webpack_public_path__ + "static/media/swiper-paginate-outer-left.b7a35d71.png";